import React, { useState } from 'react';

interface UpdateBannerProps {
  /** Exibe o banner quando há build mais recente no servidor. */
  visible: boolean;
}

/**
 * Banner fixo no topo avisando nova versão disponível.
 * Clique recarrega a página para carregar o bundle atualizado.
 */
export function UpdateBanner({ visible }: UpdateBannerProps): React.ReactElement | null {
  const [dismissed, setDismissed] = useState(false);

  if (!visible || dismissed) {
    return null;
  }

  const handleReload = (): void => {
    window.location.reload();
  };

  const handleDismiss = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    setDismissed(true);
  };

  return (
    <div
      role="alert"
      className="fixed top-0 left-0 right-0 z-[10000] flex items-center justify-center gap-3 bg-amber-500 px-4 py-2.5 text-amber-950 shadow-md cursor-pointer"
      onClick={handleReload}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleReload();
        }
      }}
      tabIndex={0}
    >
      <span className="material-symbols-outlined shrink-0 text-[22px]" aria-hidden>
        system_update
      </span>
      <p className="text-center text-sm font-semibold sm:text-base">
        Uma nova versão está disponível. Clique aqui para reiniciar o sistema
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        className="ml-1 shrink-0 rounded p-1 hover:bg-amber-600/30 focus:outline-none focus:ring-2 focus:ring-amber-900"
        aria-label="Dispensar aviso de atualização"
      >
        <span className="material-symbols-outlined text-[20px]" aria-hidden>
          close
        </span>
      </button>
    </div>
  );
}
